import { useRef } from 'react'

const useShallowStableArray = <T,>(values: readonly T[]): readonly T[] => {
  const stableValues = useRef(values)
  if (
    stableValues.current.length !== values.length ||
    stableValues.current.some((value, index) => value !== values[index])
  ) {
    stableValues.current = values
  }
  return stableValues.current
}

export default useShallowStableArray
